module.exports = __webpack_public_path__ + "static/media/001.a9300b2a.jpg";